import { IconProps } from "@/types/icons";

export const File = ({
  height = 20,
  width = 20,
  fillColor,
  decorative = false,
  ariaLabel = "File",
}: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 28 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.89019 2.27344H17.0013L21.7791 7.05122V22.829C21.7791 23.7495 21.0329 24.4957 20.1124 24.4957H7.89019C6.96972 24.4957 6.22353 23.7495 6.22353 22.829V3.9401C6.22353 3.01963 6.96972 2.27344 7.89019 2.27344ZM19.8902 6.71788L17.3346 4.16233V6.16233C17.3346 6.46915 17.5834 6.71788 17.8902 6.71788H19.8902ZM20.1124 23.3845H7.89019C7.58337 23.3845 7.33464 23.1358 7.33464 22.829V3.9401C7.33464 3.63328 7.58337 3.38455 7.89019 3.38455H16.2235V6.16233C16.2235 7.0828 16.9697 7.82899 17.8902 7.82899H20.668V22.829C20.668 23.1358 20.4192 23.3845 20.1124 23.3845ZM18.4457 10.0512H9.55686V11.1623H18.4457V10.0512ZM9.55686 12.2734H18.4457V13.3845H9.55686V12.2734ZM14.0013 14.4957H9.55686V15.6068H14.0013V14.4957Z"
        fill={fillColor ?? "#0066CC"}
      />
    </svg>
  );
};
